"use client";

import { useRouter } from "nextjs-toploader/app";
import { use } from "react";

import StateSelectorPageContainer from "@/app/(discover)/jobs/(state-selector)/components/state-selector-page.container";
import { useBestJobsStateUrl } from "@/hooks/use-best-jobs-state-url";
import {
  JOBS_DESTINATION_PARAM,
  parseJobsDestination,
} from "@/lib/jobs-destination";

type SearchParams = Record<string, string | string[] | undefined>;

export default function Page({
  searchParams,
}: {
  searchParams: Promise<SearchParams>;
}) {
  const destination = parseJobsDestination(
    use(searchParams)[JOBS_DESTINATION_PARAM],
  );

  return (
    <StateSelectorPageContainer
      destination={destination}
      useBestJobsStateUrlFn={useBestJobsStateUrl}
      useRouterFn={useRouter}
    />
  );
}
